import {setNestedValue} from "@Common/utils/arr-path";
import {cascadeFind}    from "@Common/utils/cascade";
import {chain}          from "@Common/utils/fs";

export const syncCart = async (cart, {apis, onError, actions}) => {
    let cart1 = cart;

    if (cart1.result === "failure") {
        onError(typeof cart1.errors === "string" ? cart1.errors : cart1.errors.msg);
        return;
    }

    if (cart1.status === 'processing') {
        return cart1;
    }

    for (const action of actions) {
        cart1 = await action(cart1);
    }

    cart1 = await syncBillingAccounts(cart, {apis, items: cart.items});
    if(cart1.reproofRequired)
    {
        onError("Proof files are missing for orders "+ cart1.reproofRequiredOrders.join(', ') +". Please go to customization page and regenerate the proof.");
    }
    try {
        cart1 = await apis.next.cart.validateCart(cart1.cartId);
    } catch (e) {
        onError(e);
    }

    return cart1;
};

export const syncBillingAccounts = async (cart, {items, apis}) => {
    const billingId = cascadeFind(cart, "appliedPayments.billing[*].billingId");
    const appliedBilling = cascadeFind(cart, "appliedPayments.billing[*]");

    const applyingItems = items.filter((item) =>
        cascadeFind(item, "billingAvailable.billingAccount[*].id") &&
        !cascadeFind(cart, "appliedPayments.billing[*].itemId", (itemId) => itemId === item.itemId)
    );

    if (!applyingItems.length) {
        return cart;
    }

    let applicable = false;
    const addBillingRequest = chain(
        cart,
        (_) => setNestedValue(
            _, ["payments", "billing"],
            applyingItems
                .map((item) => {
                    const applicableBilling = cascadeFind(item, "billingAvailable.billingAccount[*]");
                    if (applicableBilling){
                        applicable = true;
                    }
                    return applicableBilling && ({
                        ...appliedBilling,
                        itemId: item.itemId,
                        billingId: billingId,
                    });
                })
                .filter(v=>v)
        ),
    );
    if (applicable && appliedBilling) {
        return await apis.next.cart.updateCart(addBillingRequest);
    } else {
        return cart;
    }
};

